<div class="manual-container">
    <div class="search">
        <form [formGroup]="search">
            <input type="text" formControlName="result" placeholder="Buscar banco..." id="searcher">
        </form>
    </div>
    <!-- <table mat-table [dataSource]="params">
        <ng-container matColumnDef="CodeBank">
            <th mat-header-cell *matHeaderCellDef>C. Banco </th>
            <td mat-cell *matCellDef="let element"> {{element.CodeBank}}
            </td>
        </ng-container>
        <ng-container matColumnDef="Flag_Visible">
            <th mat-header-cell *matHeaderCellDef>Etiqueta</th>
            <td mat-cell *matCellDef="let element">
                <input style="width: 30px;" [(ngModel)]="element.Flag_Visible" type="text">
            </td>
        </ng-container>
        <ng-container matColumnDef="Name">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">
                <input [(ngModel)]="element.Name" type="text">
            </td>
        </ng-container>
        <ng-container matColumnDef="RobotPSD2">
            <th mat-header-cell *matHeaderCellDef>Robot PSD2</th>
            <td mat-cell *matCellDef="let element">
                <input [(ngModel)]="element.RobotPSD2" type="text">
            </td>
        </ng-container>
        <ng-container matColumnDef="Name_Param">
            <th mat-header-cell *matHeaderCellDef>N. párametro</th>
            <td mat-cell *matCellDef="let element">
                <input [(ngModel)]="element.Name_Param" type="text">
            </td>
        </ng-container>
        <ng-container matColumnDef="Description">
            <th mat-header-cell *matHeaderCellDef>Descripción</th>
            <td mat-cell *matCellDef="let element">
                <input [(ngModel)]="element.Description" type="text">
            </td>
        </ng-container>
        <ng-container matColumnDef="ValueParameter">
            <th mat-header-cell *matHeaderCellDef>Valor párametro</th>
            <td mat-cell *matCellDef="let element">
                <input style="width: 50px;" [(ngModel)]="element.ValueParameter" type="text">
            </td>
        </ng-container>

        <ng-container matColumnDef="Label">
            <th mat-header-cell *matHeaderCellDef>Etiqueta</th>
            <td mat-cell *matCellDef="let element">
                <input style="width: 100px;" [(ngModel)]="element.Label" type="text">
            </td>
        </ng-container>
        <ng-container matColumnDef="button">
            <th mat-header-cell *matHeaderCellDef>Actualizar párametro</th>
            <td mat-cell *matCellDef="let element">
                <button type="submit" (click)="updateRow(element)">Actualizar</button></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table> -->

    <mat-tree *ngIf="params.data" [dataSource]="params" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
            <div class="mat-tree-node">
                <button mat-icon-button disabled></button>
                <div class="object-container" style="justify-content: space-between;">
                    <div class="container-node">Nombre: <input class="space-node" type="text" placeholder="Nombre"
                            [(ngModel)]="node.Name_Param" name="" id=""></div>
                    <div class="container-node">Description: <input class="space-node" type="text"
                            placeholder="Descripción" [(ngModel)]="node.Description" name="" id=""></div>
                    <div class="container-node">Valor Parámetro: <input class="space-node" type="text"
                            placeholder="Valor parámetro" [(ngModel)]="node.ValueParameter" name="" id=""></div>
                    <div class="container-node">Etiqueta: <input class="space-node" type="text" placeholder="Etiqueta"
                            [(ngModel)]="node.Label" name="" id=""></div>
                    <button class="space-node" type="submit" (click)="updateRowNode(node)">Actualizar</button>
                </div>
            </div>
        </mat-tree-node>
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
            <div>
                <div class="mat-tree-node" [ngClass]="{'labeled': node.label}">
                    <button mat-icon-button matTreeNodeToggle>
                        <mat-icon (click)="updateCodeBank(node)" class="mat-icon-rtl-mirror">
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <strong class="bank-name">{{node.Name}}</strong>
                    <div class="object-container">
                        <div class="space" style="text-align: right;">
                            <label *ngIf="node.label" for="">Código</label>
                            <div class="code-bank">
                                {{node.CodeBank}}

                            </div>
                        </div>
                        <div class="space">
                            <label *ngIf="node.label" for="">Mostrar</label>
                            <select [(ngModel)]="node.Flag_Visible" name="" id="">
                                <option value="S">Sí</option>
                                <option value="N">No</option>
                            </select>
                        </div>
                        <div class="space">
                            <label *ngIf="node.label" for="">Nombre</label>
                            <input type="text" placeholder="Nombre" [(ngModel)]="node.Name" name="" id="">
                        </div>
                        <div class="space">
                            <label *ngIf="node.label" for="">Robot PSD2</label>
                            <input type="text" placeholder="Robot PSD2" [(ngModel)]="node.RobotPSD2" name="" id="">
                        </div>
                        <div class="space">
                            <label *ngIf="node.label" for="">90 días</label>
                            <select [(ngModel)]="node.Flag_90dias" name="" id="">
                                <option value="S">Sí</option>
                                <option value="N">No</option>
                            </select>
                        </div>
                        <button class="space" type="submit" (click)="updateRow(node)">Actualizar</button>
                    </div>
                </div>
                <ul [class.example-tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </ul>
            </div>
        </mat-nested-tree-node>
    </mat-tree>
    <!-- <mat-paginator [pageSizeOptions]="[20, 50, 100, 150, 200]" showFirstLastButtons></mat-paginator> -->
</div>
